import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";

import s from "./NoRoleAssigned.module.css";

const { Paragraph, Title } = Typography;

type NoRoleAssignedProps = {
  invalidDomain?: boolean;
};

const NoRoleAssigned = ({ invalidDomain = false }: NoRoleAssignedProps) => {
  const { t } = useTranslation();
  const translationKey = invalidDomain
    ? "components.insufficientPermissions"
    : "components.noRoleAssigned";

  return (
    <Flex vertical align="center" justify="center" className={s.container}>
      <Title className={s.title} level={1}>
        {t(`${translationKey}.title`)}
      </Title>
      <Paragraph>{t(`${translationKey}.description`)}</Paragraph>
      <Paragraph>{t(`${translationKey}.callToAction`)}</Paragraph>
    </Flex>
  );
};

export default NoRoleAssigned;
